export default __webpack_public_path__ + "static/kv-logo-m-en-439441c4d95b528e2b2d019a932dc641.png";